import { useField, useFormikContext } from 'formik';

import {
    CustomerCompanyMultiSelect,
    type CustomerCompanyMultiSelectProps,
} from '../CompanySelect/CustomerCompanyMultiSelect';

interface FormikCustomerCompanyMultiSelectProps extends Omit<CustomerCompanyMultiSelectProps, 'onChange' | 'value'> {
    name: string;
}

export function FormikCustomerCompanyMultiSelect(props: FormikCustomerCompanyMultiSelectProps) {
    const [field, meta, helpers] = useField<string[]>(props.name);
    const { validateOnChange } = useFormikContext();

    const onChange = (customerIds: string[]) => {
        helpers.setValue(customerIds);
        if (!validateOnChange && meta.error) {
            helpers.setError(undefined);
        }
    };

    return (
        <CustomerCompanyMultiSelect
            {...props}
            onChange={onChange}
            value={field.value}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : props.caption}
            onBlur={() => {
                helpers.setTouched(true);
            }}
        />
    );
}
